<template>
  <v-row>
    <v-col offset="1" cols="10">
      <v-form ref="wasteForm" v-model="formValid" lazy-validation>
        <v-col v-if="component == 'quote'" class="pa-0">
          <v-col :offset="!headerstore&&!$vuetify.breakpoint.xs ? 1:0" :cols="$vuetify.breakpoint.xs ? 12 : 10" :class="headerstore?'pa-0':''">
            <v-card-title primary-title class="text-title mb-0 py-0" :style="{ display: headerstore?'':'block'}" :class="headerstore?'text-left':'text-center'">
              {{header}}
            </v-card-title>
          </v-col>
        </v-col>

        <!-- Button Residential -->
        <!-- service="..." puts its section first, serviceLobLocked hides the other section -->
        <v-row v-if="component == 'quote'" class="service-sections mb-6 mt-3">

          <!-- For a Residence -->
          <v-col v-if="!(serviceLobLocked && businessService)" cols="12" :md="serviceLobLocked && service === 'residential' ? '12' : '6'" :order="businessService ? 1 : 0" class="pb-0 pb-md-3" :class="businessService ? 'mt-3 mt-md-0' : ''">
            <div class="section-panel section-panel--residential">
            <div class="d-flex align-center justify-center mb-3 section-header">
              <v-icon color="#175E45" size="16" class="mr-1">mdi-home-outline</v-icon>
              <span class="text-subtitle-2 font-weight-bold" style="color: #175E45;">
                {{ $t('serviceView.forResidence') }}
              </span>
            </div>
            <v-row dense class="pa-1 pt-2" style="flex: 1; align-content: flex-start;">
              <v-col v-for="option in residenceOptions" :key="option.id" cols="12" :sm="residenceOptions.length > 1 ? 6 : 12" class="d-flex" :style="$vuetify.breakpoint.xs ? '' : 'height: 100%'">
                <v-hover v-slot="{ hover }">
                  <v-card
                    outlined
                    class="option-card rounded-lg"
                    style="width: 100%; height: 100%"
                    :style="cardStyle(option, hover)"
                    @click="selectOption(option)"
                    :disabled="loading"
                  >
                    <div style="position: relative; height: 100%;">
                      <div class="radio-indicator" :style="radioStyle(option)">
                        <v-icon v-if="isSelected(option)" size="12" :color="option.color">mdi-check</v-icon>
                      </div>
                      <div class="d-flex flex-row align-center pa-2 pr-7" style="height: 100%;">
                        <div class="icon-circle flex-shrink-0 mr-2" :style="iconCircleStyle(option)">
                          <v-icon size="22" :color="isSelected(option) ? 'white' : option.color">{{ option.icon }}</v-icon>
                        </div>
                        <div class="d-flex flex-column">
                          <span :class="['text-body-2 font-weight-bold mb-0 text-left', isSelected(option) ? 'white--text' : '']">
                            {{ $t(option.text) }}
                          </span>
                          <span :class="['text-caption option-subtitle text-left', isSelected(option) ? 'white--text' : 'grey--text text--darken-1']">
                            {{ $t(option.subtitle) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            </div>
          </v-col>

          <!-- For Businesses & Organizations -->
          <v-col v-if="!(serviceLobLocked && service === 'residential')" cols="12" :md="serviceLobLocked && businessService ? '12' : '6'" class="pb-0 pb-md-3" :class="businessService ? '' : 'mt-3 mt-md-0'">
            <div class="section-panel section-panel--business">
            <div class="d-flex align-center justify-center mb-3 section-header">
              <v-icon color="#1F528F" size="16" class="mr-1">mdi-domain</v-icon>
              <span class="text-subtitle-2 font-weight-bold" style="color: #1F528F;">
                {{ $t('serviceView.forBusiness') }}
              </span>
            </div>
            <v-row dense class="pa-1 pt-2" style="flex: 1; align-content: flex-start;">
              <v-col v-for="option in businessOptions" :key="option.id" cols="12" :sm="businessOptions.length > 1 ? 6 : 12" class="d-flex" :style="$vuetify.breakpoint.xs ? '' : 'height: 100%'">
                <v-hover v-slot="{ hover }">
                  <v-card
                    outlined
                    class="option-card rounded-lg"
                    style="width: 100%; height: 100%"
                    :style="cardStyle(option, hover)"
                    @click="selectOption(option)"
                    :disabled="loading"
                  >
                    <div style="position: relative; height: 100%;">
                      <div class="radio-indicator" :style="radioStyle(option)">
                        <v-icon v-if="isSelected(option)" size="12" :color="option.color">mdi-check</v-icon>
                      </div>
                      <div class="d-flex flex-row align-center pa-2 pr-7" style="height: 100%;">
                        <div class="icon-circle flex-shrink-0 mr-2" :style="iconCircleStyle(option)">
                          <v-icon size="22" :color="isSelected(option) ? 'white' : option.color">{{ option.icon }}</v-icon>
                        </div>
                        <div class="d-flex flex-column">
                          <span :class="['text-body-2 font-weight-bold mb-0 text-left', isSelected(option) ? 'white--text' : '']">
                            {{ $t(option.text) }}
                          </span>
                          <span :class="['text-caption option-subtitle text-left', isSelected(option) ? 'white--text' : 'grey--text text--darken-1']">
                            {{ $t(option.subtitle) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
            </div>
          </v-col>
        </v-row>
        <UserDetailField :lang="lang" :country="country" :parentRefs="$refs"></UserDetailField>
        <TermsPolicy :name="name" :terms="terms" :privacy="privacy" :lang="lang"></TermsPolicy>
        <v-row v-if="serviceFormErrors || !formValid" class="my-6" >
          <div class="v-messages error--text px-6 text-center" role="alert">
            <div class="subtitle-2" >
              <v-icon class="error--text" left="left" dense="dense">mdi-alert-outline</v-icon> {{ i18n.t('missingField') }}
            </div>
          </div>
        </v-row>
        <div>
          <!-- <div class="text-center mt-0 pt-0"  v-if="isFormShowing">
            <v-btn :color=" serviceFormErrors || !formValid ? 'error' : 'success'" block  height="70px" class="rounded-lg white--text" v-ripple="loading ? false : true" @click="loading ? null : validate()">
              <span class="btn-label">
                {{ loading ? i18n.t("validate") : i18n.t("continue") }}
              </span>
              <v-progress-circular v-if="loading" class="ml-4" indeterminate="indeterminate" size="23"></v-progress-circular>
            </v-btn>
          </div> -->
          <ForwardBtn :parentRefs="$refs" currentTabComponent="ServiceView"></ForwardBtn>
        </div>
      </v-form>
  </v-col>
</v-row>
</template>
<script>

import { useUserStore } from "@/store/user";
import i18n from "@/i18n";
// import axios from "axios";
// import { load } from "recaptcha-v3";
import { useIndexStore } from '../../../store/index';
import { mapState, mapWritableState } from 'pinia';
import { mapActions } from 'pinia';
import UserDetailField from "@/components/sfc/UserDetailField";
import TermsPolicy from "@/components/sfc/TermsPolicy";
import ForwardBtn from "../utility/forwardBtn.vue";
// import BackBtn from "../utility/backBtn.vue";

export default {
  name: "ServiceView",
  components:{ForwardBtn,UserDetailField,TermsPolicy},
  props: {
    currentTabComponent: String,
    service: String,
    assigntodistrict: Number,
    lang: String,
    phone: String,
    country: String,
    terms: String,
    privacy: String,
    name: String,
    splitter: Boolean,
    load: Boolean,
    valid: Boolean,
    header: String,
    primary: String,
    secondary: String,
    storelayout: Boolean,
    portableToiletsOnly: Boolean,
  },

  data() {
    return {
      i18n: i18n,
      hover: -1,
      active: false,
      isFormShowing: true,
      fill: "",
      serviceOptions: [
        {
          id: 0,
          name: "ResidentialService",
          text: "serviceView.curbsideCollection",
          subtitle: "serviceView.curbsideCollectionSubtitle",
          leadType: "Residential",
          section: "residence",
          icon: "mdi-home-outline",
          color: "#175E45",
        },
        {
          id: 1,
          name: "ResidentialService",
          text: "serviceView.dumpsterRental",
          subtitle: "serviceView.dumpsterRentalSubtitle",
          leadType: "Residential",
          // Pre-fill so the address API call uses line=TEMP ROLL OFF and the
          // step 2 splitter has matching construction packages. Must stay in
          // sync with the case in store/index.js getLeadTypeFromServiceType.
          categoryType: i18n.t("dumpsterRental", "en"),
          section: "residence",
          icon: "mdi-dump-truck",
          color: "#175E45",
        },
        {
          id: 2,
          name: "CommercialService",
          text: "serviceView.wasteCollection",
          subtitle: "serviceView.wasteCollectionSubtitle",
          leadType: "Commercial",
          section: "business",
          icon: "mdi-office-building-outline",
          color: "#1F528F",
        },
        {
          id: 3,
          name: "CommercialService",
          text: "serviceView.constructionProjects",
          subtitle: "serviceView.constructionProjectsSubtitle",
          leadType: "Commercial",
          section: "business",
          icon: "mdi-hard-hat",
          color: "#1F528F",
        },
        // Cards 4 and 5 replace the 4 cards above for districts that only offer portable toilets (portableToiletsOnly)
        {
          id: 4,
          name: "ResidentialService",
          text: "serviceView.eventsParties",
          subtitle: "serviceView.eventsPartiesSubtitle",
          leadType: "Residential",
          section: "residence",
          icon: "mdi-party-popper",
          color: "#175E45",
        },
        {
          id: 5,
          name: "CommercialService",
          text: "serviceView.jobSitesBusinesses",
          subtitle: "serviceView.jobSitesBusinessesSubtitle",
          leadType: "Commercial",
          section: "business",
          icon: "mdi-account-hard-hat",
          color: "#1F528F",
        },
      ],
    };
  },
  created() {
      i18n.locale = this.lang;
      this.setSelectedTypeFromServiceType();

      // back() clears categoryType at Address Stage, put back the one of the selected card (Dumpster Rental)
      const option = this.serviceOptions.find(o => o.id === this.form.serviceViewOptionId);
      if (option && option.categoryType) {
        this.form.categoryType = option.categoryType;
      }
  },
  computed: {
    ...mapState(useIndexStore, [
    "formRules","headerstore","servicesType","serviceLobLocked"]),
    ...mapWritableState(useIndexStore, [
    "component",
    "apiResult",
    "apiResultOriginal",
    // "dialog",
    'formValid',
    "loading",
    // 'google',
    // 'completeAddress',
    // 'completeAddressMsg',
    // 'view',
    'serviceFormErrors',
    "button"
    ]),
    ...mapWritableState(useUserStore, [
      "form",
    ]),
    residenceOptions() {
      return this.serviceOptions.filter(o => o.section === "residence" && (o.id > 3) === this.portableToiletsOnly);
    },
    businessOptions() {
      return this.serviceOptions.filter(o => o.section === "business" && (o.id > 3) === this.portableToiletsOnly);
    },
    // service="construction" behaves like service="commercial"
    businessService() {
      return this.service === "commercial" || this.service === "construction";
    },
  },
  watch: {
    "form.serviceType": function () {
      if (this.form.serviceType) {
        this.serviceFormErrors = false;
      } else {
        this.serviceFormErrors = true;
      }
      this.setSelectedTypeFromServiceType();
    },
    // reset.quote() clears selectedTypeId but keeps a locked serviceType
    "form.selectedTypeId": function () {
      this.setSelectedTypeFromServiceType();
    },
    //Verifying if form is here.
    //if here, activate method for autoComplete

    // isFormShowing - > replace it back when demo is gone
    // isFormShowing: function (val) {
    //   if (val && !this.service) {
    //     this.$nextTick(function () {
    //       this.initializeGoogleAutocomplete();
    //     });
    //   }
    // },
  },
  methods: {
    // FOR MOUNTED AND FUNCTIONS PINIA
    ...mapActions(useIndexStore, [
    'updateViewComponent',
    'getLeadTypeFromServiceType',
    'acceptNumber',
    'updateStages',
    'warn',
    'fillSvgResidential',
    'fillSvgBusiness',
    'classSvgResidential',
    'classSvgBusiness',

  ]),

    getLeadTypeFromServiceType() {
      this.$emit("getLeadTypeFromServiceType",this.form.serviceType,this.form.categoryType);
    },

    selectOption(option) {
      if (this.loading) return;
      this.form.serviceType = option.leadType;
      this.form.selectedTypeId = option.name;
      this.form.serviceViewOptionId = option.id;
      this.form.categoryType = option.categoryType || "";
      this.serviceFormErrors = false;
    },

    // service="..." selects the first visible card of its section (wins over prefillservicetype, put back after reset)
    // otherwise serviceType set without clicking a card (prefillservicetype, locked LOB)
    // still needs selectedTypeId to navigate to ResidentialService/CommercialService
    setSelectedTypeFromServiceType() {
      if (this.form.serviceViewOptionId !== null) return;
      if (this.service === "residential" || this.businessService) {
        const options = this.businessService ? this.businessOptions : this.residenceOptions;
        // service="construction" selects Construction Projects when it's shown
        this.selectOption(options.find(o => this.service === "construction" && o.id === 3) || options[0]);
      } else if (this.form.serviceType) {
        const option = this.serviceOptions.find(o => o.leadType === this.form.serviceType);
        if (option) {
          this.form.selectedTypeId = option.name;
        }
      }
    },

    isSelected(option) {
      return this.form.serviceViewOptionId === option.id;
    },

    iconCircleStyle(option) {
      if (this.isSelected(option)) {
        return 'background-color: rgba(255,255,255,0.2);';
      }
      return `background-color: ${option.color}18;`;
    },

    radioStyle(option) {
      if (this.isSelected(option)) {
        return `background-color: white; border: 2px solid white;`;
      }
      return `background-color: transparent; border: 2px solid ${option.color}80;`;
    },

    cardStyle(option, hover) {
      const selected = this.isSelected(option);
      const borderColor = option.color;
      if (this.serviceFormErrors && !selected) {
        return `border-width: 1px !important; border-color: red !important;`;
      }
      if (selected) {
        return `border-width: 1px !important; border-color: ${borderColor} !important; background-color: ${borderColor} !important;`;
      }
      if (hover) {
        return `border-width: 1px !important; border-color: ${borderColor}60 !important; background-color: ${borderColor}14 !important;`;
      }
      return `border-width: 1px !important; border-color: ${borderColor}25 !important;`;
    },

    // function for google auto complete, update address when typing
   validate() {
      var vm = this;
      if (vm.validateFormAndService()) {
      vm.updateStages("Address Stage");
     } else {
      vm.loading = false;
     }
    },
    validateFormAndService() {
      if(!this.form.serviceType){
        this.serviceFormErrors = true;
        return this.parentRefs.wasteForm.validate() && this.form.serviceType ;
      }
      else{
        this.serviceFormErrors = false;
      }
        return this.parentRefs.wasteForm.validate();
    },
   },
};
</script>
<style scoped>
/* md breakpoint reads the window width, stack the 2 sections when the widget itself is narrow (e.g. 676px column on host page) */
.service-sections {
  container-type: inline-size;
}
@container (max-width: 860px) {
  .service-sections > .col-md-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding-bottom: 0 !important;
  }
  /* the section shown second has mt-3, mt-md-0 would remove it */
  .service-sections > .mt-3 {
    margin-top: 12px !important;
  }
}
.section-panel {
  border-radius: 8px;
  padding: 14px 12px 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.section-panel--residential {
  background-color: rgba(23, 94, 69, 0.04);
  border: 1.5px solid rgba(23, 94, 69, 0.22);
}
.section-panel--business {
  background-color: rgba(31, 82, 143, 0.04);
  border: 1.5px solid rgba(31, 82, 143, 0.22);
}
.section-header {
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.option-card {
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 12px -5px !important;
}
.option-card:not(.v-card--disabled):hover {
  box-shadow: 0 3px 10px rgba(0,0,0,0.14) !important;
}
.option-label {
  line-height: 1.25;
  word-break: break-word;
}
.radio-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}
.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}
.option-subtitle {
  line-height: 1.15 !important;
  margin-top: 2px;
}
::v-deep .larger-checkbox .v-icon {
  /* Adjust the size of the v-icon checkbox here */
  font-size: 42px !important;
}
::v-deep .input-checkbox .v-input--selection-controls__input{
  background-color: white !important;
}
::v-deep .input-checkbox.checked .v-input--selection-controls__input{
  background-color: #1BAB42 !important;
}
</style>
